import { Controller } from "@hotwired/stimulus";
import { debugLog } from "../utils";

export default class extends Controller {
  static targets = ["note", "charCounter", "error", "confirmButton"];
  static values = { max: { type: Number, default: 200 } };

  connect() {
    debugLog("NoteLimitController: Connected");
    if (this.hasCharCounterTarget) {
      this.charCounterTarget.classList.add("hidden");
    }
  }

  update(event) {
    if (!this.hasNoteTarget) {
      return;
    }

    const length = this.noteTarget.value.length;
    const max = this.maxValue;

    if (this.hasCharCounterTarget) {
      const counter = this.charCounterTarget;
      counter.textContent = `${length}/${max}`;
      counter.classList.toggle("hidden", length <= 175);
      counter.classList.toggle("text-red-400", max - length <= 20);
    }

    const overLimit = length > max;
    if (this.hasErrorTarget) {
      this.errorTarget.classList.toggle("hidden", !overLimit);
    }
    if (this.hasConfirmButtonTarget) {
      const btn = this.confirmButtonTarget;
      btn.disabled = overLimit;
      btn.classList.toggle("opacity-50", overLimit);
      btn.classList.toggle("cursor-not-allowed", overLimit);
      btn.classList.toggle("pointer-events-none", overLimit);
    }
    if (overLimit) {
      event.stopImmediatePropagation();
    }
  }
}
